export default {
      id: "weather__day-thunder-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__day-thunder",
      toString: function () {
        return this.url;
      }
    }